import Vue from "vue";
import BrowserLogger from "alife-logger";
import { version } from "../package.json";

import App from "./App";
import router from "@/router";
import store from "@/store";
import jzGeneral from "@jz/general";
import VueClipboard from "vue-clipboard2";
import "./core/use";

// ARMS
if (process.env.NODE_ENV !== "development") {
  const __bl = BrowserLogger.singleton({
    pid: "eg0azz190g@71585d06cb794d4",
    release: version,
    environment: process.env.NODE_ENV === "production" ? "prod" : "local",
    enableSPA: true,
    sendResource: true, // 上报页面静态资源
    useFmp: true, // 采集首屏FMP（First Meaningful Paint，首次有效渲染）数据
    ignore: {
      // 符合以下规则的 JS 错误不会被上报
      ignoreErrors: [
        "已取消",
        "Request aborted",
        "Cannot read property 'style' of undefined",
        "Request failed with status code 403",
        /^Script error\.?$/
      ],
      // 忽略所有内联的资源错误
      ignoreResErrors: [
        function(str) {
          if (str && str.indexOf("//m.jzyx.com") >= 0) return true; // 不上报
          return false; // 上报
        }
      ]
    }
  });
  Vue.prototype.__bl = __bl;
}

// jz general插件
window._jzGeneral = new Promise(resolve => {
  jzGeneral(
    {
      extendId: "jzyx_base_menu,jzyx_base_game",
      debug: process.env.NODE_ENV === "production" ? false : "test"
    },
    function(generalApi) {
      store.dispatch("SetCommonInfo", generalApi.source);
      generalApi.footer();
      resolve(generalApi.source);
    }
  );
});

//复制
Vue.use(VueClipboard);
//存储
import storage from "vue-ls";
Vue.use(storage, {
  namespace: "vuejs__",
  name: "ls",
  storage: "session"
});
// css
import "@/assets/less/base.less";
import "@/assets/less/resetUi.less";
// permission
import "@/permission";

//路由信息
import { ANCHOR_DATA } from "@/constants/ROUTER_DATA";
Vue.prototype._anchor = ANCHOR_DATA;
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

export default Vue;
